import { render, staticRenderFns } from "./TabFactures.vue?vue&type=template&id=8beaffce"
import script from "./TabFactures.vue?vue&type=script&lang=js"
export * from "./TabFactures.vue?vue&type=script&lang=js"
import style0 from "./TabFactures.vue?vue&type=style&index=0&id=8beaffce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports